import _fetchPage from './fetch-page'
import _fetch from './fetch'
import _create from './create'
import _update from './update'
import _updateAll from './update-all'
import _delete from './delete'
import _deleteAll from './delete-all'
import _isUnique from './is-unique'
import _countWhere from './count-where'

import { camelCase } from 'lodash'

const createViewService = options => {
  let {
    client,
    fetchPolicy = 'no-cache',
    table,
    primaryKey = ['id'],
    defaultPageSize = 25,
    defaultOrderBy,
    defaultSearchBy,
    defaultFilters = [{}],
    defaultOutput,
    defaultFragments
  } = options

  if (!client) throw new Error('client is undefined')
  if (!table) throw new Error('table is undefined')
  if (!defaultOutput) throw new Error('defaultOutput is undefined')

  const config = {
    client,
    table,
    defaultOutput,
    defaultFragments
  }

  let service = {
    fetchPage: _fetchPage({
      ...config,
      fetchPolicy,
      defaultPageSize,
      defaultOrderBy,
      defaultSearchBy,
      defaultFilters
    }),
    fetch: _fetch({
      ...config,
      fetchPolicy,
      primaryKey
    })
  }
  return service
}

const createService = options => {
  let {
    client,
    fetchPolicy = 'no-cache',
    table,
    primaryKey = ['id'],
    defaultPageSize = 25,
    defaultOrderBy,
    defaultSearchBy,
    defaultFilters,
    defaultOutput,
    defaultFragments,
    allowedFields,
    uniqueFields = []
  } = options

  if (!client) throw new Error('client is undefined')
  if (!table) throw new Error('table is undefined')
  if (!defaultOutput) throw new Error('defaultOutput is undefined')

  const config = {
    client,
    table,
    defaultOutput,
    defaultFragments
  }

  let service = {
    fetchPage: _fetchPage({
      ...config,
      fetchPolicy,
      defaultPageSize,
      defaultOrderBy,
      defaultSearchBy,
      defaultFilters
    }),
    fetch: _fetch({
      ...config,
      fetchPolicy,
      primaryKey
    }),
    create: _create({
      ...config,
      allowedFields
    }),
    update: _update({
      ...config,
      primaryKey,
      allowedFields
    }),
    updateAll: _updateAll({
      ...config,
      allowedFields
    }),
    delete: _delete({
      ...config,
      primaryKey
    }),
    deleteAll: _deleteAll({
      ...config
    })
  }

  uniqueFields.forEach(field => {
    service[`${camelCase(field)}IsUnique`] = _isUnique({ ...config, field })
  })

  return service
}

export { createService, createViewService }
